const menuItems = [
  {
    id: "issuer-home",
    title: "VW_ISSUER_MENUITEM_HOME",
    type: "item",
    url: "/issuer/dashboard",
    icon: "nc-shop",
  },
  {
    id: "issuer-new-document",
    title: "VW_ISSUER_MENUITEM_NEWDOCUMENT",
    type: "item",
    url: "/issuer/documents/new",
    icon: "nc-paper",
  },
  {
    id: "issuer-my-documents",
    title: "VW_ISSUER_MENUITEM_MYDOCUMENT",
    type: "item",
    url: "/issuer/documents/my",
    icon: "nc-basket",
  },
  {
    id: "issuer-all-documents",
    title: "VW_ISSUER_MENUITEM_ALLDOCUMENT",
    type: "item",
    url: "/issuer/documents",
    icon: "nc-single-copy-04",
  },
  {
    id: "issuer-settings",
    title: "VW_ISSUER_MENUITEM_SETTINGS",
    type: "item",
    url: "/issuer/settings",
    icon: "nc-settings-gear-65",
  },
  {
    id: "issuer-downloads",
    title: "VW_ISSUER_MENUITEM_DOWNLOADS",
    type: "item",
    url: "/issuer/downloads",
    icon: "nc-cloud-download-93",
  },
];

export default menuItems;
